import {ref} from "vue";

export function useStateAdmin()
{
    const step_back_action = ref(null);

    return {stepBackAction: step_back_action};
}
